import store from "../../store";
import {isCurrentEmcee, isCurrentHost, isGuestOnly} from "src/containers/gameTime/common/gameTimeFunctions";
import {createPublishAnnouncement, publishMessage} from "src/containers/websockets/SocketRouter";

export const allRoles = ["guardian","child","host","emcee","guest"];

export const cleanDiffs = (diff) => {
    let newDiff = Object.assign({},diff);

    for(let x in newDiff){
        if(!Array.isArray(newDiff[x]) && newDiff.hasOwnProperty(x)) {
            if (newDiff[x] === undefined) {
                delete newDiff[x];
            }
            if(newDiff[x] && newDiff[x].hasOwnProperty("length") && newDiff[x].length===0){
                delete newDiff[x];
            }

            if(newDiff[x] && typeof newDiff[x] ==='object'){
                newDiff[x]=cleanDiffs(newDiff[x]);
            }
            if(newDiff[x] && typeof newDiff[x] ==='object'){
                if(Object.keys(newDiff[x]).length===0) {
                    delete newDiff[x];
                }
                else{
                    newDiff[x] = cleanDiffs(newDiff[x]);
                }
            }
        }
    }

    return newDiff;
};


export const runAs = () => {
    let stateData= store.getState();
    let retme=[];
    if(stateData.appSettings.playerMode){
        retme.push(stateData.appSettings.playerMode)
    }
    if(isCurrentHost()){retme.push('host')}
    if(isCurrentEmcee()){retme.push('emcee')}
    if(isGuestOnly()){retme.push('guest')}
    return retme;
};

export const obtainRoleData = (role) =>{
    switch(role){
        case "guardian":
            return Object.assign({},newGuardianObject());
        case "child":
            return Object.assign({},newChildObject());
        case "host":
            return Object.assign({},newHostObject());
        case "emcee":
            return Object.assign({},newEmceeObject());
        case "guest":
            return Object.assign({},newGuestObj());
        default:
            return {};
    }
};

const newGuardianObject = () => {
    let stateData = store.getState();
    return(
        {   role:"guardian",
            data: {
                currentActivityData: {
                    playListIndex: stateData.currentActivityData.playListIndex,
                    youTubePlayState: stateData.currentActivityData.youTubePlayState
                }
            }
        }
    )
};

const newChildObject = () => {
    let stateData = store.getState();
    return(
        {
            role:"child",
            data: {
                currentActivityData: {
                    playListIndex: stateData.currentActivityData.playListIndex,
                    youTubePlayState: stateData.currentActivityData.youTubePlayState,
                    activeMedia: stateData.currentActivityData.activeMedia
                }
            }
        }
    )
};

const newHostObject=()=>{
    let stateData = store.getState();
    return({
        role:"host",
        data: {
            currentActivityData: stateData.currentActivityData,
        }
    })
};

const newEmceeObject = () => {
    let stateData = store.getState();
    return({
        role:"emcee",
        data: {
            activityResponse: stateData.activityResponse,
            gameTime: {
                currentActivityName: stateData.gameTime.currentActivityName,
                playListIndex: stateData.gameTime.playListIndex,
                chosenList: stateData.gameTime.chosenList,
                activeMedia: stateData.gameTime.activeMedia
            },
            currentActivityData: {
                playListIndex: stateData.currentActivityData.playListIndex,
                youTubePlayState: stateData.currentActivityData.youTubePlayState
            }
        }
    });
};

const newGuestObj = () => {
    let stateData = store.getState();
    //console.dir("making Guest Role");
    return ({
        role:"guest",
        data: {
            activityResponse: stateData.activityResponse,
            submitTeamForApproval: stateData.submitTeamForApproval
        }
    });
};

export const updateObjects = {
    //keyInState:{scope:NameOfKeyInSocketRouter,method:NameOfMethodInActions,message,FILLEDINLater});
    eyesOn:{scope:"eyesOnActions", method:"updateEyesOn", value: ''},
    gameTime:{scope:"gameTimeActions",method:"updateGameTime",message:''},
//    currentActivity:{scope:"gameTimeActions",method:"updateCurrentActivity",message:''},
    currentActivityData:{scope:"gameTimeActions",method:"updateCurrentActivityData",message:''},
    remoteActivityResponse:{scope:"gameTimeActions",method:'',message:''},
    submitTeamForApproval:{scope:"gameTimeTeamActions",method:"registerTeamName",message:'',type:"complete"},
    activityRemoteResponses:{scope:"gameTimeActions",method:"registerActivityAnswer"},
    teamsToAdd:{scope:"gameTimeActions",method:"registerTeamName"},
    activityResponse:{scope:"gameTimeActions",method:"addPotentialResponse"},
//    networkGuests:{scope:"gameTimeActions","method":"hereIAm"}
};

export const obtainRoleOrder = (role) =>{
    switch(role){
        case "guardian":
            return [...newGuardianOrder];
        case "child":
            return [...newChildOrder];
        case "host":
            return [...newHostOrder];
        case "emcee":
            return [...newEmceeOrder];
        case "guest":
            return [...guestOrder];
        default:
            return {};
    }
};

const newGuardianOrder=[
    "currentActivityData"
];

const newChildOrder=[
    "currentActivityData"
];

const newHostOrder=[
    "currentActivityData"
    //"networkGuests"
];
const newEmceeOrder=[
    "activityResponse",
    "currentActivityData"
];
//    "activityResponse",
const guestOrder=[
    "submitTeamForApproval",
    "activityResponse"
];

export const sendUpdate = (scope,method,message)=> {
    if(Object.keys(message).length > 0) {
        let stateData = store.getState();
        let newMessage = Object.assign({}, message);
        if (!newMessage.hasOwnProperty("originalSender")) {
            newMessage.originalSender = stateData.webSocketData.clientid;
        }
        if (stateData.gameTime?.activeRoom?.roomid) {
            publishMessage(`games.` + stateData.gameTime.activeRoom.roomid, createPublishAnnouncement(scope, method, newMessage));
        } else {
            ////console.dir("No Room Determined");
        }
    }
};
